var ContentSlides = document.querySelectorAll('.content-slide');

ContentSlides.forEach(function (slider) {
  var swiperContainer = slider.querySelector('.swiper-container');
  var swiperPagination = slider.querySelector('.swiper-pagination');
  var swiperPrev = slider.querySelector('.swiper-button-prev');
  var swiperNext = slider.querySelector('.swiper-button-next');
  var swiperInstance = null;

  // 기본 설정
  var defaultSettings = {
    slidesPerView: 'auto',
    spaceBetween: 0,
    speed: 500,
    direction: 'horizontal',
    effect: 'slide',
    grabCursor: true,
    loop: false,
    observer: true,
    observeParents: true,
    freeMode: {
      enabled: true,
      sticky: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
    navigation: false,
  };

  // 사용자 지정 dataset → 설정 반영
  var sliderSettings = {
    direction: slider.dataset.direction || defaultSettings.direction,
    slidesPerView: slider.dataset.slidesPerView || defaultSettings.slidesPerView,
    spaceBetween: parseInt(slider.dataset.spaceBetween) || defaultSettings.spaceBetween,
    speed: parseInt(slider.dataset.speed) || defaultSettings.speed,
    grabCursor: slider.dataset.grabCursor === 'false' ? false : defaultSettings.grabCursor,
    loop: slider.dataset.loop === 'true' ? true : defaultSettings.loop,
    effect: slider.dataset.effect || defaultSettings.effect,
    freeMode: {
      enabled: slider.dataset.freeMode === 'true', // data-free-mode="true"일 때만 true
      sticky: defaultSettings.freeMode.sticky,
    },
    observer: defaultSettings.observer,
    observeParents: defaultSettings.observeParents,
    autoplay: false,
    autoHeight: slider.dataset.autoHeight === 'true',
    nested: slider.dataset.nested === 'true',
    centeredSlides: slider.dataset.centeredSlides === 'true',
    navigation:
      slider.dataset.navigation === 'true'
        ? {
            prevEl: swiperPrev,
            nextEl: swiperNext,
          }
        : false,
    pagination:
      slider.dataset.pagination === 'true'
        ? {
            el: swiperPagination,
            clickable: true,
            type: slider.dataset.paginationType || 'bullets',
          }
        : false,
    breakpoints: slider.dataset.breakpoints ? JSON.parse(slider.dataset.breakpoints) : defaultSettings.breakpoints,
    thumbs: slider.dataset.thumbs
      ? {
          swiper: new Swiper(`.${slider.dataset.thumbs} .swiper-container`, {
            slidesPerView: slider.dataset.thumbsSlidesPerView || 'auto',
            spaceBetween: parseInt(slider.dataset.thumbsSpaceBetween) || 0,
            freeMode: slider.dataset.thumbsFreeMode === 'true' || false,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            slideToClickedSlide: true,
          }),
        }
      : undefined,
  };

  // autoplay dataset 처리
  if (slider.dataset.autoplayEnabled === 'true') {
    sliderSettings.autoplay = {
      //delay: parseInt(slider.dataset.autoplayDelay) || defaultSettings.autoplay.delay,
      delay:
        slider.dataset.autoplayDelay !== undefined
          ? parseInt(slider.dataset.autoplayDelay)
          : defaultSettings.autoplay.delay,
      disableOnInteraction: slider.dataset.autoplayDisableOnInteraction === 'true',
      pauseOnMouseEnter: slider.dataset.autoplayPauseOnMouseEnter === 'true',
    };
    // autoplay 켜면 freeMode 끄는게 안전
    sliderSettings.freeMode.enabled = false;
  }

  // destroy 기준 뷰포트 (없으면 null)
  var destroyBelow = parseInt(slider.dataset.destroyBelow) || null;
  var destroyAbove = parseInt(slider.dataset.destroyAbove) || null;

  // Swiper 옵션 최종 합치기
  function getSwiperOptions() {
    return {
      ...sliderSettings,
    };
  }

  // dataset으로 이벤트 조건 확인 (예시)
  /*
    if (slider.dataset.hasColorChange === "true") {
        swiperOptions.on = {
            init: function () {
                //checkColorChange();
            },
            slideChangeTransitionStart: function () {
                //checkColorChange();
            }
        };
    }
    */

  // 초기화 & destroy 관리
  function initOrDestroySwiper() {
    var windowWidth = window.innerWidth;
    var shouldDestroy = false;

    // 1. 하한선 체크 (Below): 설정값 이하일 때 해제
    if (destroyBelow && windowWidth <= destroyBelow) {
      shouldDestroy = true;
    }

    // 2. 상한선 체크 (Above): 설정값 이상일 때 해제
    if (destroyAbove && windowWidth >= destroyAbove) {
      shouldDestroy = true;
    }

    if (shouldDestroy) {
      if (swiperInstance) {
        // 해제 시 네비게이션 위치 스타일 초기화
        if (swiperPrev) swiperPrev.style.top = '';
        if (swiperNext) swiperNext.style.top = '';

        swiperInstance.destroy(true, true);
        swiperInstance = null;
        slider.swiper = null;
      }
    } else {
      // 해제 조건이 아닐 때 초기화
      if (!swiperInstance) {
        swiperInstance = new Swiper(swiperContainer, getSwiperOptions());
        slider.swiper = swiperInstance;
      }
    }
  }

  // 최초 실행
  initOrDestroySwiper();
  // 리사이즈 시 다시 체크
  window.addEventListener('resize', initOrDestroySwiper);
});
